import { ChartConfig } from '@/components/ui/chart/base';
import { ChartDatum, ChartType, ChartTypeToProps } from '@/types/charts';

import { ChartArea } from './area';
import { ChartBar } from './bar';
import { ChartLine } from './line';
import { ChartPie } from './pie';
import { ChartRadial } from './radial';
import { getChartSettings } from './utils';

const ChartComponents = {
  line: ChartLine,
  area: ChartArea,
  bar: ChartBar,
  pie: ChartPie,
  radial: ChartRadial,
} as const;

export interface ChartProps {
  data: ChartDatum[];
  chartConfig: ChartConfig;
  settings?: Partial<ChartTypeToProps[ChartType]['settings']>;
  type?: ChartType;
  className?: string;
}

const Chart = ({ data, chartConfig, type = 'line', settings, className }: ChartProps) => {
  const componentSettings = getChartSettings({
    type,
    overrides: settings ?? {},
  });

  const ChartComponent = ChartComponents[type] as React.ComponentType<ChartTypeToProps[ChartType]>;

  return <ChartComponent data={data} chartConfig={chartConfig} settings={componentSettings} className={className} />;
};

export { Chart };
